<template>
  <div v-if="enabled" class="button-width-helper">
<!--    <div v-if="completed" class="button-width-helper">-->
<!--    <div class="agenda-attended-remove"  v-if="completed">-->

<!--      <c-button-->

<!--          uppercase-->
<!--          outline-->
<!--          icon="fa-solid fa-calendar-xmark"-->
<!--          theme="danger"-->
<!--          size="sm"-->
<!--          @click="onINotAttendedClick"-->
<!--      >-->
<!--          I Did Not Attend-->
<!--      </c-button>-->
<!--    </div>-->
    <div class="agenda-attended-remove-mobile"   v-if="completed"  v-tooltip="'I Did Not Attend'">
      <c-button
          theme="default"
          size="sm"
          @click="onINotAttendedClick"
      >
        <i class="fa-regular fa-trash"></i>
      </c-button>
    </div>
<!--    </div>-->

    <div v-if="!completed">
      <c-button
          uppercase
          fill
          icon="fa-solid fa-calendar-plus"
          theme="success"
          v-if="isOverlap"
          size="sm"
          @click="onIAttendedClick"
          disabled="disabled"
          v-tooltip="'Sorry, another session conflicts with this one. Can\'t be in two places at once!'"
      >
        I Attended This Session
      </c-button>

      <c-button
          uppercase
          fill
          icon="fa-solid fa-calendar-plus"
          theme="success"
          v-if="!isOverlap"
          size="sm"
          @click="onIAttendedClick"
      >
        I Attended This Session
      </c-button>
    </div>

    <agenda-verification-form
        v-if="showVerificationModal"
        :attendee-id="attendeeId"
        :session-id="sessionId"
        @success="verificationSuccess"
        @close="showVerificationModal = false"
    />
  </div>
</template>

<script>
import AgendaVerificationForm from "./agenda-verification-form";
import agendaAPI from "../../api/agendaAPI";

export default {
  components: {
    AgendaVerificationForm
  },
  props: [
    "completed",
    "enabled",
    "isOverlap",
    "attendeeId",
    "sessionId",
    "code"
  ],
  data() {
    return {
      showIndicator: false,
      showVerificationModal: false,
    };
  },
  methods: {
    verificationSuccess() {
      agendaAPI.markAsAttended(this.attendeeId, this.sessionId)
          .then((res) => {
            this.$emit("success", res.data.data);
            this.$store.dispatch("agendaStore/replaceFlatSessions", res.data.data);
          })
          .catch(() => {
          })
          .finally(() => {
            this.showIndicator = false;
          });
    },

    onINotAttendedClick() {
      this.showIndicator = true;

      agendaAPI.markAsNotAttended(this.attendeeId, this.sessionId)
          .then((res) => {
            this.$emit("success", res.data.data);
            this.$store.dispatch("agendaStore/replaceFlatSessions", res.data.data);
          })
          .catch(() => {
          })
          .finally(() => {
            this.showIndicator = false;
          });
    },

    onIAttendedClick() {
      this.showIndicator = true;

      if (this.code?.enabled && !this.code?.confirmed) {
        this.showVerificationModal = true;
      } else {
        this.showVerificationModal = false;

        agendaAPI.markAsAttended(this.attendeeId, this.sessionId)
            .then((res) => {
              this.$emit("success", res.data.data);
              this.$store.dispatch("agendaStore/replaceFlatSessions", res.data.data);
            })
            .catch(() => {
            })
            .finally(() => {
              this.showIndicator = false;
            });
      }
    },
  },
};
</script>

<style lang="scss">

//.agenda-attended-remove{
//  display: block;
//  @media (max-width: 767px) {
//      display: none;
//  }
//}
//
//.agenda-attended-remove-mobile{
//  display: none;
//
//  @media (max-width: 767px) {
//    display: block;
//  }
//}

.button-width-helper {
  display: inline;
  @media (max-width: 900px) {
    width: 100%;
  }
}
</style>
